import { Page } from "modules/common/components/page/Page";
import React from "react";
import { AuthDialog } from "./AuthDialog";
import { AuthFormProps } from "./AuthForm";
import styles from "./AuthPage.module.scss";

export const AuthPage = ({ store }: AuthPageProps) => {
    return (
        <Page className={styles.page}>
            <AuthDialog store={store} dimmed={false} />
        </Page>
    );
};

interface AuthPageProps extends AuthFormProps {}
